import {styled} from '@mui/material/styles';

export const RootContainer = styled("div")`
    width: 100%;
    height: 100%;
    position: relative;
`;